import Router from "vue-router";
import Vue from "vue";
import AdminRoute from "./routes/admin";
Vue.use(Router);
//var allroutes=[]
//allroutes=allroutes.concat(AdminRoute,UserRoute)
const routes = AdminRoute;
let router = new Router({
    mode: "history",
    base: "/",
    routes,
});
export default router;
